// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"BackBtn-module--back-btn--2XXX3"};